export const IMAGES = [
	{
		category: "Airport",
		path: require("photo-backgrounds/airplane/Airplane1-1.jpg"),
	}, {
		category: "Airport",
		path: require("photo-backgrounds/airplane/Airplane1.jpg"),
	}, {
		category: "Airport",
		path: require("photo-backgrounds/airplane/Airport1.jpg"),
	}, {
		category: "Amusement Parks",
		path: require("photo-backgrounds/amusement-parks/DelMarFair1.jpg"),
	}, {
		category: "Amusement Parks",
		path: require("photo-backgrounds/amusement-parks/Disney1.jpg"),
	}, {
		category: "Amusement Parks",
		path: require("photo-backgrounds/amusement-parks/KnottsBerry1.jpg"),
	}, {
		category: "Amusement Parks",
		path: require("photo-backgrounds/amusement-parks/SeaWorld1.jpg"),
	}, {
		category: "Amusement Parks",
		path: require("photo-backgrounds/amusement-parks/UniversalStudios2.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Dog1.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Dog2.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Dolphin1.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Dolphin2.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Dolphin3.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Elebhant1.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Elephant2.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Elephant3.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Flamingos1.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Flamingos2.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Flamingos3.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Goat1.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Koala1.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Lion1.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Lion2.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Orca1.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Orca2.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Orca3.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Owl1.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Owl2.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Owl3.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Owl4.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Penguins1.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Sheep1.jpeg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Sheep2.jpeg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Tiger1.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Tiger2.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Turtle1.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Turtle2.jpg"),
	}, {
		category: "Animals",
		path: require("photo-backgrounds/animals/Turtle3.jpg"),
	}, {
		category: "Black & White Images",
		path: require("photo-backgrounds/black-and-white-images/B_W1.jpg"),
	}, {
		category: "Black & White Images",
		path: require("photo-backgrounds/black-and-white-images/B_W10.jpg"),
	}, {
		category: "Black & White Images",
		path: require("photo-backgrounds/black-and-white-images/B_W11.jpg"),
	}, {
		category: "Black & White Images",
		path: require("photo-backgrounds/black-and-white-images/B_W12.jpg"),
	}, {
		category: "Black & White Images",
		path: require("photo-backgrounds/black-and-white-images/B_W2.jpg"),
	}, {
		category: "Black & White Images",
		path: require("photo-backgrounds/black-and-white-images/B_W3.jpg"),
	}, {
		category: "Black & White Images",
		path: require("photo-backgrounds/black-and-white-images/B_W4.jpg"),
	}, {
		category: "Black & White Images",
		path: require("photo-backgrounds/black-and-white-images/B_W5.jpg"),
	}, {
		category: "Black & White Images",
		path: require("photo-backgrounds/black-and-white-images/B_W6.jpg"),
	}, {
		category: "Black & White Images",
		path: require("photo-backgrounds/black-and-white-images/B_W8.jpg"),
	}, {
		category: "Black & White Images",
		path: require("photo-backgrounds/black-and-white-images/B_W9.jpg"),
	}, {
		category: "Black & White Images",
		path: require("photo-backgrounds/black-and-white-images/_W7.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/China1.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/Dubai1.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/Dubai2.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/India1.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/India2.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/India3.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/London1.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/London2.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/London3.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/London4.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/London5.jpeg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/London5.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/Mexico1.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/Mexico2.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/NewYork1.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/NewYork2.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/NewYork3.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/NewYork4.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/Paris1.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/Paris2.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/Paris3.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/Rome1.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/Rome2.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/Rome3.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/SanDiego1.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/SanDiego2.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/SanDiego3.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/Switzerland2.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/Tokyo.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/Tokyo2.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/Venice1.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/Venice2.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/WashingtonDC1.jpg"),
	}, {
		category: "Cities & Countries",
		path: require("photo-backgrounds/cities-countries/WhiteHouse1.jpeg"),
	}, {
		category: "National & State Parks",
		path: require("photo-backgrounds/national-state-parks/GrandCanyon1.jpg"),
	}, {
		category: "National & State Parks",
		path: require("photo-backgrounds/national-state-parks/NiagaraFalls1.jpg"),
	}, {
		category: "National & State Parks",
		path: require("photo-backgrounds/national-state-parks/NiagaraFalls2.jpg"),
	}, {
		category: "National & State Parks",
		path: require("photo-backgrounds/national-state-parks/NiagraFalls3.jpg"),
	}, {
		category: "National & State Parks",
		path: require("photo-backgrounds/national-state-parks/NiagraFalls4.jpg"),
	}, {
		category: "National & State Parks",
		path: require("photo-backgrounds/national-state-parks/Sequoia National Park1.jpg"),
	}, {
		category: "National & State Parks",
		path: require("photo-backgrounds/national-state-parks/Yosemite1.jpeg"),
	}, {
		category: "National & State Parks",
		path: require("photo-backgrounds/national-state-parks/Yosemite3.jpg"),
	}, {
		category: "National & State Parks",
		path: require("photo-backgrounds/national-state-parks/Zion1.jpg"),
	}, {
		category: "Nature",
		path: require("photo-backgrounds/nature/Beach1.jpg"),
	}, {
		category: "Nature",
		path: require("photo-backgrounds/nature/Beach3.jpg"),
	}, {
		category: "Nature",
		path: require("photo-backgrounds/nature/Desert1.jpg"),
	}, {
		category: "Nature",
		path: require("photo-backgrounds/nature/Desert2.jpg"),
	}, {
		category: "Nature",
		path: require("photo-backgrounds/nature/Desert3.jpg"),
	}, {
		category: "Nature",
		path: require("photo-backgrounds/nature/Snow1.jpg"),
	}, {
		category: "Nature",
		path: require("photo-backgrounds/nature/Snow3.jpg"),
	}, {
		category: "Around The House",
		path: require("photo-backgrounds/places-in-the-house/Bedroom1.jpg"),
	}, {
		category: "Around The House",
		path: require("photo-backgrounds/places-in-the-house/Bedroom2.jpg"),
	}, {
		category: "Around The House",
		path: require("photo-backgrounds/places-in-the-house/House1.jpg"),
	}, {
		category: "Around The House",
		path: require("photo-backgrounds/places-in-the-house/House3.jpg"),
	}, {
		category: "Around The House",
		path: require("photo-backgrounds/places-in-the-house/Kitchen1.jpg"),
	}, {
		category: "Around The House",
		path: require("photo-backgrounds/places-in-the-house/Kitchen2.jpg"),
	}, {
		category: "Around The House",
		path: require("photo-backgrounds/places-in-the-house/Kitchen3.jpg"),
	}, {
		category: "Places To Hang Out After School",
		path: require("photo-backgrounds/places-to-hang-out-after-school/CoffeeShop1.jpg"),
	}, {
		category: "Places To Hang Out After School",
		path: require("photo-backgrounds/places-to-hang-out-after-school/CoffeeShop2.jpg"),
	}, {
		category: "Places To Hang Out After School",
		path: require("photo-backgrounds/places-to-hang-out-after-school/CoffeeShop3.jpg"),
	}, {
		category: "Places To Hang Out After School",
		path: require("photo-backgrounds/places-to-hang-out-after-school/IceCreamParlor1.jpg"),
	}, {
		category: "Places To Hang Out After School",
		path: require("photo-backgrounds/places-to-hang-out-after-school/IceCreamTruck1.jpg"),
	}, {
		category: "Places To Hang Out After School",
		path: require("photo-backgrounds/places-to-hang-out-after-school/Mall1.jpg"),
	}, {
		category: "Places To Hang Out After School",
		path: require("photo-backgrounds/places-to-hang-out-after-school/Mall2.jpg"),
	}, {
		category: "Random Backgrounds",
		path: require("photo-backgrounds/random-backgrounds/InstaBG1.jpg"),
	}, {
		category: "Random Backgrounds",
		path: require("photo-backgrounds/random-backgrounds/InstaBG11.jpg"),
	}, {
		category: "Random Backgrounds",
		path: require("photo-backgrounds/random-backgrounds/InstaBG12.jpg"),
	}, {
		category: "Random Backgrounds",
		path: require("photo-backgrounds/random-backgrounds/InstaBG2.jpg"),
	}, {
		category: "Random Backgrounds",
		path: require("photo-backgrounds/random-backgrounds/InstaBG3.jpg"),
	}, {
		category: "Random Backgrounds",
		path: require("photo-backgrounds/random-backgrounds/InstaBG4.jpg"),
	}, {
		category: "Random Backgrounds",
		path: require("photo-backgrounds/random-backgrounds/InstaBG7.jpg"),
	}, {
		category: "Random Backgrounds",
		path: require("photo-backgrounds/random-backgrounds/InstaBG8.jpg"),
	}, {
		category: "Random Backgrounds",
		path: require("photo-backgrounds/random-backgrounds/InstaBG9.jpg"),
	}, {
		category: "School",
		path: require("photo-backgrounds/school/Cafeteria1.jpg"),
	}, {
		category: "School",
		path: require("photo-backgrounds/school/Classroom1.jpg"),
	}, {
		category: "School",
		path: require("photo-backgrounds/school/Classroom2.jpg"),
	}, {
		category: "School",
		path: require("photo-backgrounds/school/Field1.jpg"),
	}, {
		category: "School",
		path: require("photo-backgrounds/school/Lockers1.jpg"),
	}, {
		category: "School",
		path: require("photo-backgrounds/school/Playground1.jpg"),
	}
]


// WEBPACK FOOTER //
// ./modules/lib/games/PhotoBackgrounds.js